import styles from "./css-modules/chartFlexRow.module.css";

export const ChartFlexRow = ({children}) => {
  return <div className={styles.flexRow} style={{ display: "flex" }}>
    {children}
  </div>;
};
